
import React, { Component } from 'react';
import { connect } from "react-redux";
import {
    firebaseFire as Libfirebase,
} from '../helpers/firebase-config.js';
import { Collapse } from 'reactstrap';
import PreLoaderWidget from '../components/Loader.js';
import ReactPlayer from 'react-player'

class Tutoriais extends Component {
    state = {
        loading: true,
        tutoriais: [],
        transportes: true,
    }

    async componentDidMount() {
        const tutoriaisDb = await Libfirebase.collection("tutoriais").get()
        let tutoriais = []
        tutoriaisDb.docs.forEach(t => { tutoriais.push(t.data()) })
        // tutoriais.sort((a, b) => a.tipo = b.tipo)
        // console.log(tutoriais)
        const grouped = Object.groupBy(tutoriais, ({ tipo }) => tipo);
        let tutorialGroups = Object.entries(grouped).map(([k, v]) => k)

        let obj = {}
        tutorialGroups.forEach(g => obj[g] = true)
        console.log(obj)

        this.setState({ tutoriais: grouped, loading: false, ...obj })
    }

    render() {
        return (
            <React.Fragment>
                {this.state.loading && <center>
                    <PreLoaderWidget ></PreLoaderWidget>
                </center>}
                {!this.state.loading &&
                    <div className="card-protocolos">

                        <h2 className="title-protocolos">Tutoriais do sistema</h2>

                        <div className="accordion" id="accordionTutorial">
                            <div className="card">
                                {Object.entries(this.state.tutoriais).map(([k, v]) => {
                                    console.log(k)
                                    console.log(v)
                                    console.log(this.state)
                                    console.log(this.state[k])
                                    return (
                                        <React.Fragment>
                                            <div
                                                className="card-header gb-table-row"
                                                id="headingOne"
                                                onClick={() => {
                                                    let obj = {}
                                                    obj[k] = !this.state[k]
                                                    this.setState({ ...obj })
                                                }}
                                                style={{ cursor: 'pointer' }}>
                                                <div className="mb-0 mt-0 gb-row-between">
                                                    <div className="gb-row">Tutoriais de {k}</div>
                                                    <i className="fas fa-chevron-down"></i>
                                                </div>
                                            </div>

                                            <Collapse isOpen={this.state[k]}>
                                                <div className="card-body">
                                                    {
                                                        v.map((video, idx) => {
                                                            return (
                                                                <React.Fragment key={idx}>
                                                                    <p style={{ fontSize: "18px", fontWeight: "bold", marginTop: "20px" }}> - {video.title}</p>
                                                                    <ReactPlayer
                                                                        width="100%"
                                                                        url={video.link}
                                                                        controls={true}
                                                                    />
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    }

                                                </div>
                                            </Collapse>
                                        </React.Fragment>
                                    )
                                })}


                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }
}

export default connect()(Tutoriais);